/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui";
import { Link, useNavigate } from "react-router-dom";

export function BreadCrumb({ items, className }) {
  const navigate = useNavigate();
  return (
    <Breadcrumb className={`mt-5 ${className}`}>
      <BreadcrumbList className="items-center">
        {items.map((item, index) => (
          <div className="flex flex-row items-center gap-1.5" key={index}>
            <BreadcrumbItem>
              {item.to || item.type === "previous" ? (
                <BreadcrumbLink>
                  <Link
                    to={item.to}
                    onClick={() => {
                      if (item.type === "previous") {
                        navigate(-1);
                      }
                    }}
                  >
                    {item.text}
                  </Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{item.text}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {item.to ? <BreadcrumbSeparator /> : <></>}
          </div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
